// extracted by mini-css-extract-plugin
export default {"intro-wrapper":"Intro_intro-wrapper__1lUlI","social-wrapper":"Intro_social-wrapper__iMesT","icon":"Intro_icon__Q-eC7"};